import { useClient, useDictionary, useOrder } from '@adamlip/okeoke.client';
import { PayAPI } from 'apis/PayApi';
import SimplePayAgreement from 'components/SimplePay/SimplePayAgreement';
import SimplePayRecurringAgreement from 'components/SimplePay/SimplePayRecurringAgreement';
import useStorage from 'hooks/useStorage';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BeatLoader from 'react-spinners/BeatLoader';
import { Logger } from 'utils/Logger-v1';
import GeneralBackref from './GeneralBackref';

function SimplePay() {
  const { id } = useParams();
  const { getValue } = useDictionary();
  const { languageCode } = useClient();
  const { getSV } = useStorage();
  const navigate = useNavigate();

  const [orderUUID, setOrderUUID] = useState(null);
  const { paymentState } = useOrder(null, orderUUID);
  const [paymentAgentID, setPaymentAgentID] = useState(null);
  const [simplePayCardID, setSimplePayCardID] = useState(null);
  const [link, setLink] = useState(null);
  const [price, setPrice] = useState(null);
  const [transactionId, setTransactionId] = useState(null);
  const [error, setError] = useState(null);
  const [simplePaySuccess, setSimplePaySuccess] = useState('loading');
  const [countDown, setCountDown] = useState(null);
  const [buttonState, setButtonState] = useState('loading');
  const timer = useRef(null);

  useEffect(() => {
    setSimplePayCardID(parseInt(getSV('simplePayCardID') || -1));
    return () => {
      clearTimeout(timer.current);
    };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (countDown != null) {
      timer.current = setTimeout(() => {
        setError(true);
        setCountDown(null);
      }, 1000);
    }
  }, [countDown]);

  useEffect(() => {
    if (id != null) {
      let params = id.split('-');
      setOrderUUID(params[0]);
      setPaymentAgentID(params[1]);
    }
  }, [id]);

  useEffect(() => {
    if (simplePaySuccess && link != null) setButtonState('navigateToSimple');
  }, [link, simplePaySuccess]);

  useEffect(() => {
    if (error) setButtonState('error');
  }, [error]);

  useEffect(() => {
    if (orderUUID != null && paymentAgentID != null && typeof languageCode === 'string') start();
    // eslint-disable-next-line
  }, [languageCode, orderUUID, paymentAgentID]);

  const handleTryAgain = () => {
    setError(null);
    start();
  };

  const start = () => {
    setButtonState('loading');
    setSimplePaySuccess('loading');

    if (paymentState?.paymentUrl != null) {
      window.location.href = paymentState?.paymentUrl;
    } else {
      let data = {
        orderUUID: orderUUID,
        languageCode: languageCode,
        backRef: window.location.origin + '/brandApp/simplepaybackref',
        storeCard: simplePayCardID === 0,
        paymentAgentID: paymentAgentID,
        cardID: simplePayCardID > 0 ? simplePayCardID : undefined,
      };

      PayAPI.startOkePay(data)
        .then((response) => {
          console.log('SimplePay response:', response.data);
          Logger.add('SimplePay response: ' + JSON.stringify(response.data));
          if (response.data.success) {
            setSimplePaySuccess(true);
            setLink(response.data.data.paymentUrl);
            setPrice(response.data.data.amount);
            setTransactionId(response.data.data.transactionId);
          } else {
            setSimplePaySuccess(false);
            setCountDown(true);
            if (response.data.message === 'Order not in compatible state.') navigate(`/orderview/${orderUUID}`);
          }
        })
        .catch((e) => {
          console.error(e);
          setCountDown(true);
        });
    }
  };

  if (simplePayCardID > 0) return <GeneralBackref transactionID={transactionId} success={simplePaySuccess} orderUUID={orderUUID} paymentAgent='SimplePay' />;

  return (
    <div className='simple-pay-root'>
      <SimplePayAgreement />
      {simplePayCardID === 0 && <SimplePayRecurringAgreement />}
      <p className='simple-pay-acceptStatement'>{getValue('app_v2_acceptStatement')}</p>
      <div className='simple-pay-logo-container'>
        <a href={'https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf'} download target='_blank' rel='noopener noreferrer'>
          <img className='simple-logo' src={`https://cdn.okeoke.io/brands/global/payments/simple_pay.jpg`} alt='simpleLogo' height={'100px'} />
        </a>
      </div>
      <div className={`btn ${buttonState === 'loading' || buttonState === 'error' ? 'disabled' : 'primary'}`}>
        {buttonState === 'loading' && (
          <div className='hidden-content appear'>
            <BeatLoader color={'#fff'} />
          </div>
        )}
        {buttonState === 'navigateToSimple' && <a href={link}>{`${getValue('app_v2_simple_startPayment')} (${price} Ft)`}</a>}
        {buttonState === 'error' && getValue('app_v2_simple_error')}
      </div>
      {buttonState === 'error' && (
        <div className='btn primary hidden-content appear' onClick={handleTryAgain}>
          {getValue('app_v2_simple_tryAgain')}
        </div>
      )}
    </div>
  );
}

export default SimplePay;
